import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  // 课程表
  function studentsManage(onlineClass) {
    router.push({
      path: "dataTraining/classSchedule",
      query: { id: onlineClass.uuid },
    });
  }
  // 学员考勤
  // function goClassGroup(onlineClass) {
  //   router.push({
  //     path: "dataTraining/attendance",
  //     query: { classId: onlineClass.uuid },
  //   });
  // }
  // 作业管理
  function noticeList(onlineClass) {
    router.push({
      path: "dataTraining/jobManagement",
      query: { classId: onlineClass.uuid },
    });
  }

  // 测试管理
  function fileLibraryList(onlineClass) {
    router.push({
      path: "dataTraining/testManage",
      query: { classId: onlineClass.uuid },
    });
  }

  function fullMarkCheck(onlineClass) {
    router.push({
      path: "dataTraining/fullMarkCheck",
      query: { classId: onlineClass.uuid },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    const dealConf = onlineClass.childNum > 0 ? [
      ["icon_xiaoban_data", "小班数据", () => {
        router.push({
          path: "dataTraining/smallClassData",
          query: { classId: onlineClass.uuid },
        });
      }, ""],
    ] : [
      ["icon_kechengbiao_icon", "课程表", () => studentsManage(onlineClass), ""],
      // ["icon_kaoqin_icon", "学员考勤", () => goClassGroup(onlineClass), ""],
      ["icon_zuoy_icon", "作业管理", () => noticeList(onlineClass), ""],
      ["icon_cesh_icon", "测试管理", () => fileLibraryList(onlineClass), ""],
      ["iconfont icxueyuanshuzihuaxiang iconfont-adapt", "学员数字画像", () => fullMarkCheck(onlineClass), ""],
    ]

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );



  };

  const AccountTableConfig = [
    {
      label: "班级名称",
      minWidth: "180",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            router.push({
              path: "/onlineClass/detail",
              query: { id: vo.row.uuid }
            });
          }}
        >
          {vo.row.className}
        </el-button>
      )
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "承办单位",
      prop: "undertakeUnit",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "班级类型",
      width: "150",
      prop: "trainTypeName",
      showOverflowTooltip: true,
    },
    {
      label: "办班级别",
      prop: "classLevelName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "班级状态",
      prop: "classStatusName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "开始时间",
      prop: "trainStartTime",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "结束时间",
      prop: "trainEndTime",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "学制(天)",
      prop: "trainDays",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "报名情况",
      prop: "enrollSituation",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "班主任",
      prop: "headTeacher",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      fixed: "right",
      width: "140",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
